<template>
  <div id="join">
    <div class="search">
      <el-input
        placeholder="请输入查找的用户名"
        clearable
        prefix-icon="el-icon-search"
        v-model.trim="formMore.Username"
      ></el-input>
      <el-select
        ref="choose"
        clearable
        v-model.trim="more"
        placeholder="更多筛选"
        @focus="moreSelect()"
      >
      </el-select>
      <el-button type="warning" @click="search1()" size="mini">搜索</el-button>
     
      
      <el-button
        type="primary"
        plain
        size="small"
        icon="el-icon-plus"
        @click="addClick()"
        v-if="userAdd"
        >新增</el-button
      >
      <el-button type="danger" @click="batchDelete()" size="mini" v-if="userAllDel">批量删除</el-button>
      <!-- <el-button @click="resFuntion">重置</el-button> -->
    </div>
    <el-row>
      <el-col :span="5">
        <div
          style="
            width: 80%;
            border: 1px solid #d9d9d9;
            margin: 10px auto;
            height: 550px;
          "
        >
          <el-tree
            :data="organizationData"
            :check-on-click-node="true"
            :expand-on-click-node="false"
            show-checkbox
            node-key="id"
            :check-strictly="true"
            @check="orgClick"
            :default-expanded-keys="[
              '00000000-0001-0001-0002-000000000000',
              '00000000-0001-0001-0002-000000010000'
            ]"
            ref="searchTree"
            :default-checked-keys="orgList"
          >
          </el-tree>
        </div>
      </el-col>
      <el-col :span="19">
        <el-table
          :data="tableData"
          :header-cell-style="{ textAlign: 'center' }"
          :row-style="getRowStyle"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          row-key="id"
        >
        <el-table-column type="selection" width="50" :reserve-selection="true"></el-table-column>
          <el-table-column prop="username" label="用户名" width="240">
          </el-table-column>
          <el-table-column prop="nikename" label="姓名" sortable>
          </el-table-column>
          <el-table-column prop="tel" label="手机号" width="200">
          </el-table-column>
          <el-table-column
            prop="orgName"
            label-width="200px"
            label="所属部门"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="criminalRiskControler"
            label="刑事风险控制人"
            width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.criminalRiskControler == true ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="depManager" label="部门主管" width="150">
            <template slot-scope="scope">
              {{ scope.row.depManager == true ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="riskControler" label="风控委员" width="150">
            <template slot-scope="scope">
              {{ scope.row.riskControler == true ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="practice" label="实习生" width="150">
            <template slot-scope="scope">
              {{ scope.row.practice == true ? '是' : '否' }}
            </template>
          </el-table-column>

          <el-table-column label="功能" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="small"
                plain
                @click="editClick(scope.row)"
                v-if="userUpdate"
                >编辑</el-button
              >
              <el-dropdown style="margin-left: 10px">
                <el-button type="primary" size="small" plain>
                  更多功能<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="forbidClick(scope.row)"
                    :disabled="scope.row.status == 1 && userAble"
                  >
                    {{
                      scope.row.status == 1 ? '已禁用' : '禁用用户'
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native="openClick(scope.row)"
                    :disabled="scope.row.status == 0 && userAble"
                    >{{
                      scope.row.status == 0 ? '已启用' : '启用用户'
                    }}</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native="resetClick(scope.row)"
                    v-if="userReset"
                    >修改密码</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native="resetPassword(scope.row)"
                    v-if="ResetPassword&&(scope.row.status==0||scope.row.status==6)"
                    >重置密码</el-dropdown-item
                  >
                  <el-dropdown-item @click.native="deleteClick(scope.row)">
                    删除用户
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes"
            :total="Total"
          ></el-pagination>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="Total"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 新增用户dialog -->
    <el-dialog
      :title="dialogFormTitle"
      :visible.sync="dialogAddVisible"
      width="90%"
      center=""
      @closed="closeForm()"
    >
      <div style="display: flex">
        <div style="width: 20%; margin-right: 2%">
          <el-form
            ref="addRuleForm"
            :model="addForm"
            label-width="100px"
            :rules="addRules"
          >
            <el-form-item label="用户名 :" prop="username">
              <el-input v-model.trim="addForm.username" class="sel-input-all" />
            </el-form-item>
            <el-form-item label="姓名/昵称 :" prop="nikename">
              <el-input v-model.trim="addForm.nikename" class="sel-input-all" />
            </el-form-item>
            <el-form-item label="手机号 :" prop="tel">
              <el-input v-model.trim="addForm.tel" class="sel-input-all" />
            </el-form-item>
            <!-- <el-form-item label="所属部门 :" prop="department">
              <el-input v-model.trim="addForm.department" class="sel-input-all" />
            </el-form-item> -->
            <el-form-item label="刑事风险控制人 :" prop="criminalRiskControler">
              <el-select
                v-model="addForm.criminalRiskControler"
                placeholder="请选择"
                class="sel-input-all"
                clearable
                @change="changeInitialMenu()"
              >
                <el-option
                  v-for="item in isRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否是风控委员 :" prop="riskControler">
              <el-select
                v-model="addForm.riskControler"
                placeholder="请选择"
                class="sel-input-all"
                clearable
                @change="changeInitialMenu()"
              >
                <el-option
                  v-for="item in isRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否是部门管理员 :" prop="depManager">
              <el-select
                v-model="addForm.depManager"
                placeholder="请选择"
                class="sel-input-all"
                clearable
                @change="changeInitialMenu()"
              >
                <el-option
                  v-for="item in isRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否是实习生 :" prop="practice">
              <el-select
                v-model="addForm.practice"
                placeholder="请选择"
                class="sel-input-all"
                clearable
              >
                <el-option
                  v-for="item in isRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="二次审批人权限" prop="other">
              <el-select
                v-model="addForm.approveList"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="案件二次审批权限:" prop="approveListCase">
              <el-select
                v-model="addForm.approveListCase"
                multiple
                placeholder="请选择"
                @change="changeInitialMenu()"
              >
                <el-option
                  v-for="item in CaseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用章二次审批权限:" prop="Sealother">
              <el-select
                v-model="addForm.approveListSeal"
                multiple
                placeholder="请选择"
                @change="changeInitialMenu()"
              >
                <el-option
                  v-for="item in SealOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二次利冲审批人:" prop="conflict" v-if="isZong">
              <el-select
                v-model="addForm.conflict"
                @change="changeInitialMenu()"
                placeholder="请选择"
                class="sel-input-all"
                clearable
              >
                <el-option
                  v-for="item in isRisk"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div
          style="width: 20%; height: 700px; overflow-y: auto; margin: 0 20px"
        >
          <el-tree
            :data="menuData"
            show-checkbox
            node-key="id"
            ref="limittree"
            :default-checked-keys="addForm.menuList"
            :check-on-click-node="true"
            :expand-on-click-node="false"
            :props="defaultProps"
            check-strictly
            @check-change="MenuChecked"
          >
          </el-tree>
        </div>
        <div style="width: 30%; height: 600px; overflow-y: auto">
          <el-tree
            :data="organizationData"
            show-checkbox
            node-key="id"
            :check-on-click-node="true"
            :expand-on-click-node="false"
            :check-strictly="true"
            @check="handleClick"
            :default-expanded-keys="[
              '00000000-0001-0001-0002-000000000000',
              '00000000-0001-0001-0002-000000010000'
            ]"
            ref="tree"
            :default-checked-keys="addForm.orgId"
          >
          </el-tree>
        </div>
        <div style="width: 30%; height: 600px; overflow-y: auto">
          <div>全部案件查看权限</div>
          <el-tree
            :data="organizationData"
            show-checkbox
            node-key="id"
            :check-on-click-node="true"
            :expand-on-click-node="false"
            :check-strictly="true"
            :default-expanded-keys="[
              '00000000-0001-0001-0002-000000000000',
              '00000000-0001-0001-0002-000000010000'
            ]"
            ref="chargeList"
            :default-checked-keys="addForm.chargeList"
          >
          </el-tree>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmClick()">确定</el-button>
        <el-button type="warning" @click="closeForm()">取消</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码dialog -->
    <el-dialog
      title="修改密码"
      :visible.sync="messageVisible"
      width="720px"
      append-to-body
      @closed="messageCancel()"
    >
      <el-form
        ref="messageform"
        :model="messageForm"
        :rules="messgaeRule"
        label-width="100px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item prop="OldPassword">
              <span slot="label"> 原密码 </span>
              <el-input
                v-model="messageForm.OldPassword"
                placeholder="请输入原密码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="NewPassword">
              <span slot="label"> 新密码 </span>
              <el-input
                v-model="messageForm.NewPassword"
                placeholder="请输入新密码"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="messageSubmitForm">确 定</el-button>
        <el-button @click="messageCancel">取 消</el-button>
      </div>
    </el-dialog>

    <!--更多选择!-->
    <el-dialog
      title="更多筛选"
      :visible.sync="dialogMoreVisible"
      width="40%"
      center=""
      @closed="closeMoreForm()"
    >
      <el-form
        ref="formMore"
        :model="formMore"
        label-width="90px"
        style="min-height: 400px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名">
              <el-input
                class="select"
                v-model.trim="formMore.Username"
                clearable
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input
                class="select"
                v-model.trim="formMore.Nikename"
                clearable
                placeholder="请输入申请姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户手机号">
              <el-input
                class="select"
                v-model.trim="formMore.Tel"
                clearable
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属组织">
              <el-cascader
                clearable
                v-model="formMore.OrgId"
                :props="{ checkStrictly: true }"
                :options="selectOrganization"
                popper-class="cascader"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
         
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户状态">
              <el-select
                v-model="formMore.status"
                clearable
                placeholder="请选择用户状态"
                filterable
              >
                <el-option
                  v-for="item in userStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="search1()">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>
   
<script>
import {
  searchMenuList,
  OrganizationList,
  searchMemberList,
  deleteMemberList,
  updateMemberList,
  addMemberList,
  updatePassword,
  pidOrganization,
  ResetPassword,
  UserDelete,
} from '../../api/set.js'

export default {
  name: 'user',
  data() {
    // 用户名验证
    var checkuser = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('用户名不能为空'))
      }
      let reguser = /^[a-zA-Z0-9_-]{4,16}$/
      setTimeout(() => {
        if (!reguser.test(value)) {
          callback(new Error('请输入4到16的用户名'))
        } else {
          callback()
        }
      }, 500)
    }
    return {
     
      orgList: [],
      isTree: false,
      dataTree: '',
      openOrg: [
        '00000000-0001-0001-0002-000000000000',
        '00000000-0001-0001-0002-000000010000'
      ],
      count: 0,
      list: [],
      loading: true,
      formMore: {
        Username: '',
        Nikename: '',
        Tel: '',
        OrgId: '',
        status:null,
      },
      userStatus:[  { label: '正常', value: 0 },
        { label: '禁用', value: 1 }],
      //新增用户信息
      addForm: {
        username: '',
        nickname: '',
        tel: '',
        orgId: [],
        depManager: '',
        riskControler: '',
        criminalRiskControler: '',
        practice: '',
        // approveList: '',
        approveListCase: [],
        approveListSeal: [],
        conflict:null,
      },
      isRisk: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      //用章二次审批权限
      SealOptions: [
        {
          value: 'official_seal',
          label: '公章'
        },
        {
          value: 'corporate_seal',
          label: '法人章'
        },
        {
          value: 'contract_seal',
          label: '合同章'
        },
        {
          value: 'official_corporate_seal',
          label: '公章+法人章'
        },
        {
          value: 'contract_corporate_seal',
          label: '合同章+法人章'
        },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],
      //案件二次审批权限
      CaseOptions: [
        {
          value: 'case_00000000-0000-0000-0001-000000000000',
          label: '民事案件	'
        },
        {
          value: 'case_00000000-0001-0001-0002-000000000000',
          label: '刑事案件	'
        },
        {
          value: 'case_00000000-0002-0002-0003-000000000000',
          label: '行政案件	'
        },
        {
          value: 'case_00000000-0003-0003-0004-000000000000',
          label: '执行案件	'
        },
        {
          value: 'case_00000000-0006-0006-0007-000000000000',
          label: '一般非诉项目	'
        },
        {
          value: 'case_00000000-0007-0007-0008-000000000000',
          label: '单独出具法律意见审批书	'
        },
        {
          value: 'case_00000000-0008-0008-0009-000000000000',
          label: '单独出具律师函		'
        },
        {
          value: 'case_00000000-0009-0009-0010-000000000000',
          label: '其他与法律服务有关的招投标引项目栏			'
        },
        {
          value: 'case_00000000-0010-0010-0011-000000000000',
          label: '专项服务合同		'
        },
        {
          value: 'case_00000000-0011-0011-0012-000000000000',
          label: '破产案件			'
        },
        {
          value: 'case_00000000-0012-0012-0013-000000000000',
          label: '破产案件投标		'
        },
        {
          value: 'case_00000000-0004-0004-0005-000000000000',
          label: '劳动仲裁案件			'
        },
        {
          value: 'case_00000000-0005-0005-0006-000000000000',
          label: '商事仲裁案件		'
        },
        {
          value: 'case_00000000-0013-0013-0014-000000000000',
          label: '证券类业务		'
        },
        {
          value: 'case_00000000-0014-0014-0015-000000000000',
          label: '律师见证		'
        },
        {
          value: 'adviser',
          label: '顾问		'
        },
        {
          value: 'Tender',
          label: '投标		'
        }
      ],
      addOptions: [
        {
          value: 'official_seal',
          label: '公章'
        },
        {
          value: 'corporate_seal',
          label: '法人章'
        },
        {
          value: 'contract_seal',
          label: '合同章'
        },
        {
          value: 'official_corporate_seal',
          label: '公章+法人章'
        },
        {
          value: 'contract_corporate_seal',
          label: '合同章+法人章'
        },
        {
          value: 'case_00000000-0000-0000-0001-000000000000',
          label: '民事案件	'
        },
        {
          value: 'case_00000000-0001-0001-0002-000000000000',
          label: '刑事案件	'
        },
        {
          value: 'case_00000000-0002-0002-0003-000000000000',
          label: '行政案件	'
        },
        {
          value: 'case_00000000-0003-0003-0004-000000000000',
          label: '执行案件	'
        },
        {
          value: 'case_00000000-0006-0006-0007-000000000000',
          label: '一般非诉项目	'
        },
        {
          value: 'case_00000000-0007-0007-0008-000000000000',
          label: '单独出具法律意见审批书	'
        },
        {
          value: 'case_00000000-0008-0008-0009-000000000000',
          label: '单独出具律师函		'
        },
        {
          value: 'case_00000000-0009-0009-0010-000000000000',
          label: '其他与法律服务有关的招投标引项目栏			'
        },
        {
          value: 'case_00000000-0010-0010-0011-000000000000',
          label: '专项服务合同		'
        },
        {
          value: 'case_00000000-0011-0011-0012-000000000000',
          label: '破产案件			'
        },
        {
          value: 'case_00000000-0012-0012-0013-000000000000',
          label: '破产案件投标		'
        },
        {
          value: 'case_00000000-0004-0004-0005-000000000000',
          label: '劳动仲裁案件			'
        },
        {
          value: 'case_00000000-0005-0005-0006-000000000000',
          label: '商事仲裁案件		'
        },
        {
          value: 'adviser',
          label: '顾问		'
        },
        {
          value: 'Tender',
          label: '投标		'
        }
      ],
      addRules: {
        // username: [{required: true, trigger: 'blur', validator: checkuser }],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        nikename: [
          { required: true, message: '请输入姓名/昵称', trigger: 'blur' }
        ],
        tel: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        depManager: [
          { required: true, message: '请输入是否为部门管理员', trigger: 'blur' }
        ],
        practice: [
          { required: true, message: '请选择是否为实习生', trigger: 'blur' }
        ],
        criminalRiskControler: [
          {
            required: true,
            message: '请选择是否为刑事风险控制人',
            trigger: 'blur'
          }
        ],
        riskControler: [
          { required: true, message: '请选择是否为风控委员', trigger: 'blur' }
        ]
      },
      //修改密码信息
      messageVisible: false,
      messageForm: {},
      passwordId: '',
      messgaeRule: {
        OldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        NewPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      },
      menuData: [],
      intialMenu1: [],
      idArr: [],
      // intialMenu: ["a8bc1e81-fed2-44b0-9eee-d073f6f1ad6f", "7d4aaf08-b7e9-49a4-93cb-51f0c81c7627", "67695157-73cb-46ba-8aaf-01a09d4a22c4",
      //   "1c960074-76f8-41e7-af61-24cceeba0c82", "b09db061-4e21-4b17-aa04-00450a461059", "a9596c1b-6e1c-4a79-b82c-e715e2ad6919", "0fcaf9f9-1e89-4e83-9daa-b35bb374e349",
      //   "9f6b9120-2f2b-445d-9238-684645e74ff7", "3d901bd1-49b7-4c70-916c-98484b437852", "df8c55dd-2633-4c92-9c84-96502ef2e796", "b3556676-daa9-4868-b52d-dc200e0d4a47",
      //   "1b47c75a-085d-4391-ba1f-ecf5e0cbe7a9", "3a01c1ec-e2b0-4246-97d0-70c505c276a6", "88c5e846-70b9-40f8-ba42-e6a804756bbb", "18647d3e-d6ff-4def-93df-e3cdef9c9b59",
      //   "dc7e44da-7718-4f53-9c59-8862699d9348", "a7819ee7-c6a1-43a2-9e98-3c692e4463b0"
      // ],
      intialMenu: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      organizationData: [],
      arrorgId: [],
      selectOrganization: [],
      isPage: true,
      more: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      dialogAddVisible: false,
      dialogMoreVisible: false,
      dialogFormTitle: '',
      form: {},
      Total: 0,
      dialogVisible: false,
      userUpdate: false,
      userDelete: false,
      userReset: false,
      userAble: false,
      userAdd: false,
      ResetPassword:false,

      //批量删除
      selectedRows:[],// 存储所有选中的行
      selectedRowIds: new Set(),
      isZong:false,//是否是总所下面的人
      userAllDel:false,
    }
  },
  mounted() {
    this.userUpdate = this.$store.state.rolesname.includes('userUpdate')
    this.userDelete = this.$store.state.rolesname.includes('userDelete')
    this.userReset = this.$store.state.rolesname.includes('userReset')
    this.userAble = this.$store.state.rolesname.includes('userAble')
    this.userAdd = this.$store.state.rolesname.includes('userAdd')
    
    this.ResetPassword=this.$store.state.rolesname.includes('UserResetPassword')
    this.userAllDel = this.$store.state.rolesname.includes('userAllDel')
    this.search()
    this.getmenuList()
    this.getOrganizationList(), this.getSelectOrganization()

  },

  methods: {
    //   getRowStyle(row, index) {
    //   return {
    //     background: row.status === 1 ? '#f7f7f7' : '#fff'
    //   };
    // },
    getRowStyle({ row, rowIndex }) {
      if (row.status == 1) {
        return {
          background: '#F5F7FA'
        }
      }
    },

    //设置组织只能选择一个
    orgClick(data, tree) {
      console.log('节点被选中:', data);
      this.$refs.searchTree.setCheckedKeys([]) // 删除所有选中节点
      this.$refs.searchTree.setCheckedNodes([])
      // this.$refs.searchTree.setCheckedNodes([data]) // 选中已选中节点

      if (this.dataTree !== data.id) {
        this.$refs.searchTree.setCheckedNodes([data]) // 选中已选中节点
        this.orgSearch(data.id, 1)
      } else {
        if (this.isTree) {
          this.$refs.searchTree.setCheckedNodes([data]) // 选中已选中节点
          this.orgSearch(data.id, 1)
        } else {
          this.orgSearch()
        }
        this.isTree = !this.isTree
      }
      if(this.formMore.OrgId != data.id){
        this.formMore.OrgId= data.id
        this.clearAllSelection()
      }
      
      this.dataTree = data.id
    },
    //设置组织只能选择一个
    handleClick(data, tree) {
      this.$refs.tree.setCheckedKeys([]) // 删除所有选中节点
      this.$refs.tree.setCheckedNodes([])
      this.$refs.tree.setCheckedNodes([data]) // 选中已选中节点
      if(data.code.includes("org-jk02f-")){
        this.isZong=true
      }else{
        this.isZong=false
        this.addForm.conflict=null
      }
    },

    //获取菜单列表
    getmenuList() {
      let Params = {
        rows: 100,
        page: this.currentPage
      }
      searchMenuList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.menuData = res.data.data
            this.intialMenu1 = res.data.data
            this.filterMenu()
          } else {
            this.$message.error('数据获取失败')
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
    },
    //过滤默认菜单
    filterMenu() {
      //用户设置，审批，承办律师，归档
      let arr = this.intialMenu1.filter((el) => {
        return (
          el.id != 'f243af84-9956-4fd5-bb77-8b4985d064f3' &&
          el.id != '78ba94ef-3ea6-4170-a5a4-83d850f5a1bb' &&
          // el.id != 'b3556676-daa9-4868-b52d-dc200e0d4a47' &&
          el.id != '486edc5f-677e-4d21-8622-f0b9bf13f3ac'
        )
      })
      //包含了所有删除，还有全部案件，用章审批，和投标审批
      // var newArr = [
      //   '88074ff5-4ec8-49b2-ba15-3fe08e2318e6',
      //   'fc2b12f7-3b0e-458f-bab4-2bf5fb83acae',
      //   '04114bbd-0c01-45d9-8a34-96e2d0868d6d',
      //   'bece7f82-3c60-4af2-a75c-d4e4821a6815',
      //   'c54b8bff-ff0b-434a-b875-abbafd42446e',
      //   '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
      //   '4d0c334e-2fde-45a7-ac33-b907185989b2',
      //   'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
      //   '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
      //   '9ac30434-6083-4f67-85cd-94e12e99f30d',
      //   'aca40b83-8c45-4d50-b251-c01293c7fb66',
      //   '861c7468-4888-4143-ace9-ad96fae18a13',
      //   '367da928-1ab5-4183-8653-1b016e0e7f0f',
      //   '8c62b3e1-7be8-4aa2-9bc5-2d04d3175be3',
      //   'df9142a1-dbb6-413d-a145-747ab0401f1f',
      //   '1f9e9a99-838f-4eee-b2f3-d4b53c048f1b',
      //   'a85a43f4-f8f6-41e6-a6e1-f44c6faf9dbe',
      //   '6b08e6fd-d9a2-4713-ae3e-58404a7ecefd',
      //   '435ed88f-954c-4ab1-bdb0-9f2153b9f25a',
      //   '6ea098ae-19bb-4ad8-9c0b-9744a8a318b2',
      //   '58e7f87e-488b-4cee-8670-2ddd24a5c202',
      //   '882c74af-353f-4f28-8151-93f76f544ed3',
      //   '2816a25c-fcd6-4c6a-93d1-7c7f03190350',
      //   'b7e37d59-fc78-4d68-8fca-21ae989545c7',
      //   'eca8a9cd-8281-486c-beae-f98cd611018f',
      //   '01d46385-67d0-4a55-b6a4-fa9ebf4cebc9',
      //   'e641abc8-c5c3-49b7-b4a5-737911a3b8e7',
      //   '2f63efa0-0714-4b54-a599-e75a473c321d',
      //   'd0769d69-9cb9-4ab0-af67-bbd144b4ebe2',
      //   '835502fd-0572-4680-bda3-6408e6c2ae63',
      //   'd430dc90-f352-44c0-8763-2396ebca5b61',
      //   'da9f7d5d-7f04-468b-8f28-f77a17c4249f',
      //   '65693754-7826-42e5-bce6-d64a3532f277',
      //   '934ff88c-2928-46cf-8236-8304e362442e',
      //   '37fec0d9-72a2-41fb-8d02-cc2c8a804a21',
      //   '4aad1c9f-2dc9-4e0b-b080-d947bedec06e',
      //   '7048a989-56a0-4216-a865-a86ca98ba11c',
      //   'f3ad7ed8-bd05-4927-8857-2821a52dd78c',
      //   '2527fd51-8064-45d5-892b-e63e870fb8cb',
      //   'd50f50f9-a532-4484-a71a-86731f76b154',
      //   'b0f98896-e2a4-4fc5-9f7f-6ead0cf2f1c6',
      //   'bece7f82-3c60-4af2-a75c-d4e4821a6815',
      //   '66f7c482-58dc-4f23-89d9-f93037689859',
      //   'da55650b-b03a-4b94-af98-94026b6548f1',
      //   '5907d892-dd4a-4a0f-9897-d5d079ecf304',
      //   'ba9d1e26-3786-4639-a862-288de21241ff',
      //   '11bd4118-8b0c-4a21-8a53-7dbeec6b27e8'

      // ]
      var newArr = [
        'a8bc1e81-fed2-44b0-9eee-d073f6f1ad6f',
        '7d4aaf08-b7e9-49a4-93cb-51f0c81c7627',//首页
        '67695157-73cb-46ba-8aaf-01a09d4a22c4',//通知
        '1c960074-76f8-41e7-af61-24cceeba0c82',
        'b09db061-4e21-4b17-aa04-00450a461059',
        'c42c5917-36ca-4abc-9a83-9b5e52b75b0f',
        '9f6b9120-2f2b-445d-9238-684645e74ff7',
        '2272f1d6-809f-438b-9544-3075345ceed9',
        '5fc87bb1-b6e1-4eba-b79d-281675b1150b',
        '368085ae-e7f3-4521-a628-2bbf9b636490',
        'a9596c1b-6e1c-4a79-b82c-e715e2ad6919',
        '0fcaf9f9-1e89-4e83-9daa-b35bb374e349',
        'ca3e8804-8f0d-48f1-bfa0-c5da9e869da8',
        '98152077-bacb-47b1-a84e-98c63b1ddfd9',
        '3d901bd1-49b7-4c70-916c-98484b437852',//审批申请
        'df8c55dd-2633-4c92-9c84-96502ef2e796',
        'b3556676-daa9-4868-b52d-dc200e0d4a47',
        '1b47c75a-085d-4391-ba1f-ecf5e0cbe7a9',
        '3a01c1ec-e2b0-4246-97d0-70c505c276a6',
        'be50ec64-d36a-4e78-aab1-2302116987ab',
        'c3b79cc4-0a74-4893-a000-71f0a8e1ad15',
        '4cb9fb12-653a-4d0d-9430-1e61c07895a2',
        '662d45d1-d9c0-498b-88d7-8801c1ace884',
        '2f74890d-2b1a-4ae0-9767-7fad93d296a9',
        '88c5e846-70b9-40f8-ba42-e6a804756bbb',
        '18647d3e-d6ff-4def-93df-e3cdef9c9b59',
        'dc7e44da-7718-4f53-9c59-8862699d9348',
        'a7819ee7-c6a1-43a2-9e98-3c692e4463b0',
        'd00b80e9-dea6-475f-9244-f81dfe80b48e',
        '1c93f237-ef4b-4500-8770-733e4802d293',
        '729f6286-6577-447b-8e08-7e62873c2065',
        '3bc98cc0-c04b-4d10-8874-b1198aea62b9',
        '242fd653-3b44-4bf9-ad10-ab33d6f3132a',
        'fb39905a-504c-4cef-ac17-83030356ba5b',
        '08436571-7a14-488b-9025-5121013cd812',
        'c1392003-a8d5-4b80-b5c3-63cdc92915a4',
        'ca11a8fc-3099-4edd-a8eb-d852f887a319',
        '4d72e085-8546-40c2-99cd-36b0271a6b54',
        '8dadb0e1-5d05-49cf-88e3-b24831fd80f4',
        '0579e360-458e-4b53-b5df-a810d71549cd',
        '559f8ea0-1c18-4113-a3ae-633f94a0c02a',
        '86fa8f82-b4c3-423a-9334-1c3bcc3df3ae',
        '0e730ede-144c-4c7e-8313-c2b4c5158ac2',
        '6c4f84cc-56b6-43be-9b9b-4748737de382',
        '8897c3f2-6ab9-4f9e-93c7-926f5de7ea53',
        '25fa8f82-b4c3-423a-9334-1c3bcc3df3ae',
        '12fa8f82-b4c3-423a-9334-1c3bcc3df3ae',
        '1503e4eb-27ba-4891-ba9e-f15f918b1fde',
        '2b7052a7-2821-4044-80ea-27060f9624c8',
        '0f8c15b4-52e7-4f8d-bd39-166f957d08ea',
        '9090d66f-43b6-4c24-b7b8-7e024efb7065',
        '1c84cf2b-87b2-4d15-b65a-a47c4c47c2c3',
        '72d467d0-0cf7-4ac0-b479-03a97c8362f4',
        '5c28cc89-ce1b-4fd6-b427-33b6cf816a10',
        'de4fe5bc-62c6-4c75-a364-7d1d24fefeeb',
        'd0ef31ae-bf44-431f-8014-9c2d9bb19744',
        'c8309f55-3fcc-4f05-8bf0-b2f5d21bc875',
        'ca013775-7c06-4060-b218-3aa5217ba347',
        '61e7c42e-5715-4aa3-bcce-cd29a1cbb0cd',
        '7c741a76-c21c-4e22-8997-5a33513fc7f6',
        '869294de-9a63-480d-9d47-01c87962c7d3',
        'dd10c26b-2b4b-4f01-b21a-861ff60c90ef',
        '8bf94317-74fe-41f1-91c1-e961bec8c249',
        '81456d7f-cd65-4c5d-841c-ab3887f0e38d',
        'dcf03d6a-6975-4082-b6d2-0abf1b0f64f7',
        '6ef22a09-8ace-4dbf-96ca-cf9d4ede7abc',
        'c6ff2306-546a-4c75-8a41-3cad3875783a',
      ]
      this.dgHandle(arr)
      this.intialMenu=newArr;
      // this.idArr.forEach((el, index) => {
      //   if (newArr.indexOf(el) == -1) {
      //     this.intialMenu.push(el)
      //   }
      // })
    },
   
    dgHandle(arr) {
      arr.forEach((el, index) => {
        this.idArr.push(el.id)
        if (el.children.length != 0) {
          this.dgHandle(el.children)
        }
      })
    },
    // 菜单树中复选框选中变化
    MenuChecked: function (data, check) {
      if (check) {
        // debugger
        // if(data.children.length > 0){
        //   for( var i in data.children){
        //     this.$refs.limittree.setChecked(data.children[i].id, true, false)
        //   }
        // }
        this.$refs.limittree.setChecked(data.pid, true, false)
      } else {
        for (var i in data.children) {
          this.$refs.limittree.setChecked(data.children[i].id, false, true)
        }
      }
    },

    //获取组织列表
    getOrganizationList() {
      let Params = {
        rows: 100,
        page: this.currentPage
      }
      OrganizationList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            let arr1 = JSON.parse(JSON.stringify(res)).data.data
            this.organizationData = arr1
          } else {
            this.$message.error('数据获取失败')
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
    },
    //获取所属组织列表
    getSelectOrganization() {
      pidOrganization()
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.selectOrganization = res.data.data
          } else {
            this.$message.error('数据获取失败')
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
    },
    //更改级联选择器
    handleChange(value) {
      if (value) {
        this.formMore.OrgId = value[value.length - 1]
        // console.log(this.formMore.OrgId)
       
      }
    },

    search1() {
      if(this.formMore.OrgId){
        this.$refs.searchTree.setCheckedKeys([]);
        this.orgList = [this.formMore.OrgId];
        // 设置新的选中节点
        this.$refs.searchTree.setCheckedKeys(this.orgList);
      }
      this.clearAllSelection()
      this.currentPage = 1
      this.search()
    },

    //搜索
    search() {
      let Params = {
        Username: this.formMore.Username == '' ? null : this.formMore.Username,
        Nikename: this.formMore.Nikename == '' ? null : this.formMore.Nikename,
        Tel: this.formMore.Tel == '' ? null : this.formMore.Tel,
        OrgId: this.formMore.OrgId == '' ? null : this.formMore.OrgId,
        Status:this.formMore.status==''?null:this.formMore.status,
        rows: this.pageSize,
        page: this.currentPage
      }
      searchMemberList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.tableData = res.data.data

            this.Total = res.data.total
          } else {
            this.$message.error('查询出错')
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
      this.dialogMoreVisible = false
    },
    //组织搜索
    orgSearch(id, val) {
      this.currentPage = val
      let Params = {
        Username: this.formMore.Username == '' ? null : this.formMore.Username,
        Nikename: this.formMore.Nikename == '' ? null : this.formMore.Nikename,
        Tel: this.formMore.Tel == '' ? null : this.formMore.Tel,
        Status:this.formMore.status==''?null:this.formMore.status,
        OrgId: id,
        rows: this.pageSize,
        page: val
      }
      searchMemberList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.tableData = res.data.data

            this.Total = res.data.total
          } else {
            this.$message.error('查询出错')
          }
        })
        .catch(() => {
          this.$message.error('查询出错')
        })
      this.dialogMoreVisible = false
    },

    //分页
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      if (this.$refs.searchTree.getCheckedNodes().length != 0) {
        this.orgSearch(this.$refs.searchTree.getCheckedNodes()[0].id, val)
      } else {
        this.search()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.$refs.searchTree.getCheckedNodes().length != 0) {
        this.orgSearch(this.$refs.searchTree.getCheckedNodes()[0].id, val)
      } else {
        this.search()
      }
    },
    changeStatus(row) {
      ChangeStatus({
        id: row.id,
        status: 9
      })
    },
    //新增
    addClick() {
      this.dialogFormTitle = '添加用户'
      this.addForm = {
        menuList: this.intialMenu
      }
      this.dialogAddVisible = true
      setTimeout(() => {
        this.$refs.limittree.setCheckedKeys(this.intialMenu)
      }, 10)
    },
    //点击是否是管理员
    changeInitialMenu() {
      if (this.addForm.depManager == true||(this.addForm.approveListSeal!=null&&this.addForm.approveListSeal.length>0)) {
        //包含了案件审批，用章审批，投标审批和全部案件
        let arr = [
          '78ba94ef-3ea6-4170-a5a4-83d850f5a1bb',
          '0f643717-24a1-4290-ac34-a1ab4c94aecd',
          '67091148-bb86-4376-9e01-aa76f86046fa',
          '35e6af5f-e7e5-40e8-aa08-6565669d03a1',
          '26e1a994-1e53-497b-b9bf-f0950c8e8b77',
          '3e15d5b7-70eb-4fc0-a31f-204a1362fbd3',
          'ca0ca2f8-cdfe-4e33-a067-6b6770847f01',
          '8c62b3e1-7be8-4aa2-9bc5-2d04d3175be3',
          'df9142a1-dbb6-413d-a145-747ab0401f1f',
          '1f9e9a99-838f-4eee-b2f3-d4b53c048f1b',
          'f34107f3-3a21-4442-8284-0106a0cdedfc',
          '22802200-1427-47ab-93a1-aa33bf20837e',
          'a85a43f4-f8f6-41e6-a6e1-f44c6faf9dbe',
          '6b08e6fd-d9a2-4713-ae3e-58404a7ecefd',
          '435ed88f-954c-4ab1-bdb0-9f2153b9f25a',
          '6ea098ae-19bb-4ad8-9c0b-9744a8a318b2',
          '58e7f87e-488b-4cee-8670-2ddd24a5c202',
          '85119374-93ca-4dc6-a447-40b90b427e73',
          'bcc57b67-af17-42cc-a5c1-82aed973d764',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          '367da928-1ab5-4183-8653-1b016e0e7f0f',
          '26963258-9a01-4f50-9489-7d6490c0c7e9',
          'da9f7d5d-7f04-468b-8f28-f77a17c4249f',
          '65693754-7826-42e5-bce6-d64a3532f277',
          '934ff88c-2928-46cf-8236-8304e362442e',
          '4aad1c9f-2dc9-4e0b-b080-d947bedec06e',
          '7048a989-56a0-4216-a865-a86ca98ba11c',
          'f3ad7ed8-bd05-4927-8857-2821a52dd78c',
          'd50f50f9-a532-4484-a71a-86731f76b154',
          'b0f98896-e2a4-4fc5-9f7f-6ead0cf2f1c6',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '66f7c482-58dc-4f23-89d9-f93037689859',
          'da55650b-b03a-4b94-af98-94026b6548f1',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          'ca2241ba-d1fe-4877-b37a-a9f3080e8428',
          '11bd4118-8b0c-4a21-8a53-7dbeec6b27e8',
          '24ab0774-80b6-41c5-9890-6a76dd1f6062',
          '0c39f779-ce6e-4392-bb7c-bd8a80e8be51',
          '3841ace9-f179-4c56-9824-64df459ec6b0',
          'f1212981-366b-4bec-ad7b-2de61372de39',
          '58a27259-c7a8-4a9c-b5ff-ade33cc27f95',
          '5b4f7128-8b99-4556-84ba-1e865679c75e',
          '54b9af26-85b6-42d7-8327-ca9e1855b7e9',
          'f8aa3a55-f862-46df-aef6-e065d3c49755',
          'ba9d1e26-3786-4639-a862-288de21241ff',
          '5b28d180-96da-4733-93f8-bfaf62dd2cd4',
          '9ffb01d5-012c-4e15-bd4c-0c210c3e06cf',
          '312de42b-f57a-46ea-b850-e9248c3a6371',
          '52c9baf6-3dc5-4ea7-9c63-41c640157abe',

        ]
        this.addForm.menuList = this.addForm.menuList.concat(arr)
        this.$refs.limittree.setCheckedKeys(this.addForm.menuList)
      } else {
        if ((this.addForm.approveListCase!=null&&this.addForm.approveListCase.length>0)||this.addForm.riskControler == true||this.addForm.criminalRiskControler == true
        ||this.addForm.conflict == true){
          //包含了案件审批，用章审批，投标审批和全部案件
          let arr = [
          '78ba94ef-3ea6-4170-a5a4-83d850f5a1bb',
          '0f643717-24a1-4290-ac34-a1ab4c94aecd',
          '67091148-bb86-4376-9e01-aa76f86046fa',
          '35e6af5f-e7e5-40e8-aa08-6565669d03a1',
          '26e1a994-1e53-497b-b9bf-f0950c8e8b77',
          '3e15d5b7-70eb-4fc0-a31f-204a1362fbd3',
          'ca0ca2f8-cdfe-4e33-a067-6b6770847f01',
          // '8c62b3e1-7be8-4aa2-9bc5-2d04d3175be3',//用章审批
          // 'df9142a1-dbb6-413d-a145-747ab0401f1f',
          // '1f9e9a99-838f-4eee-b2f3-d4b53c048f1b',
          // 'f34107f3-3a21-4442-8284-0106a0cdedfc',
          // '22802200-1427-47ab-93a1-aa33bf20837e',
          // 'a85a43f4-f8f6-41e6-a6e1-f44c6faf9dbe',
          '6b08e6fd-d9a2-4713-ae3e-58404a7ecefd',
          '435ed88f-954c-4ab1-bdb0-9f2153b9f25a',
          '6ea098ae-19bb-4ad8-9c0b-9744a8a318b2',
          '58e7f87e-488b-4cee-8670-2ddd24a5c202',
          '85119374-93ca-4dc6-a447-40b90b427e73',
          'bcc57b67-af17-42cc-a5c1-82aed973d764',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          '367da928-1ab5-4183-8653-1b016e0e7f0f',
          '26963258-9a01-4f50-9489-7d6490c0c7e9',
          'da9f7d5d-7f04-468b-8f28-f77a17c4249f',
          '65693754-7826-42e5-bce6-d64a3532f277',
          '934ff88c-2928-46cf-8236-8304e362442e',
          '4aad1c9f-2dc9-4e0b-b080-d947bedec06e',
          '7048a989-56a0-4216-a865-a86ca98ba11c',
          'f3ad7ed8-bd05-4927-8857-2821a52dd78c',
          'd50f50f9-a532-4484-a71a-86731f76b154',
          'b0f98896-e2a4-4fc5-9f7f-6ead0cf2f1c6',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '66f7c482-58dc-4f23-89d9-f93037689859',
          'da55650b-b03a-4b94-af98-94026b6548f1',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          'ca2241ba-d1fe-4877-b37a-a9f3080e8428',
          '11bd4118-8b0c-4a21-8a53-7dbeec6b27e8',
          '24ab0774-80b6-41c5-9890-6a76dd1f6062',
          '0c39f779-ce6e-4392-bb7c-bd8a80e8be51',
          '3841ace9-f179-4c56-9824-64df459ec6b0',
          'f1212981-366b-4bec-ad7b-2de61372de39',
          '58a27259-c7a8-4a9c-b5ff-ade33cc27f95',
          '5b4f7128-8b99-4556-84ba-1e865679c75e',
          '54b9af26-85b6-42d7-8327-ca9e1855b7e9',
          'f8aa3a55-f862-46df-aef6-e065d3c49755',
          'ba9d1e26-3786-4639-a862-288de21241ff',
          '5b28d180-96da-4733-93f8-bfaf62dd2cd4',
          '9ffb01d5-012c-4e15-bd4c-0c210c3e06cf',
          '312de42b-f57a-46ea-b850-e9248c3a6371',
          '52c9baf6-3dc5-4ea7-9c63-41c640157abe',

          ]
          this.addForm.menuList=this.intialMenu
          this.addForm.menuList = this.addForm.menuList.concat(arr)
          this.$refs.limittree.setCheckedKeys(this.addForm.menuList)
        }else{
          this.$refs.limittree.setCheckedKeys(this.intialMenu)
        }
      }
    },

    changeInitialMenuCase(){
      console.log("123")
      if (this.addForm.approveListCase.length>0||this.addForm.riskControler == true||this.addForm.criminalRiskControler == true){
          //包含了案件审批，用章审批，投标审批和全部案件
          let arr = [
          '78ba94ef-3ea6-4170-a5a4-83d850f5a1bb',
          '0f643717-24a1-4290-ac34-a1ab4c94aecd',
          '67091148-bb86-4376-9e01-aa76f86046fa',
          '35e6af5f-e7e5-40e8-aa08-6565669d03a1',
          '26e1a994-1e53-497b-b9bf-f0950c8e8b77',
          '3e15d5b7-70eb-4fc0-a31f-204a1362fbd3',
          'ca0ca2f8-cdfe-4e33-a067-6b6770847f01',
          // '8c62b3e1-7be8-4aa2-9bc5-2d04d3175be3',//用章审批
          // 'df9142a1-dbb6-413d-a145-747ab0401f1f',
          // '1f9e9a99-838f-4eee-b2f3-d4b53c048f1b',
          // 'f34107f3-3a21-4442-8284-0106a0cdedfc',
          // '22802200-1427-47ab-93a1-aa33bf20837e',
          // 'a85a43f4-f8f6-41e6-a6e1-f44c6faf9dbe',
          '6b08e6fd-d9a2-4713-ae3e-58404a7ecefd',
          '435ed88f-954c-4ab1-bdb0-9f2153b9f25a',
          '6ea098ae-19bb-4ad8-9c0b-9744a8a318b2',
          '58e7f87e-488b-4cee-8670-2ddd24a5c202',
          '85119374-93ca-4dc6-a447-40b90b427e73',
          'bcc57b67-af17-42cc-a5c1-82aed973d764',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          '367da928-1ab5-4183-8653-1b016e0e7f0f',
          '26963258-9a01-4f50-9489-7d6490c0c7e9',
          'da9f7d5d-7f04-468b-8f28-f77a17c4249f',
          '65693754-7826-42e5-bce6-d64a3532f277',
          '934ff88c-2928-46cf-8236-8304e362442e',
          '4aad1c9f-2dc9-4e0b-b080-d947bedec06e',
          '7048a989-56a0-4216-a865-a86ca98ba11c',
          'f3ad7ed8-bd05-4927-8857-2821a52dd78c',
          'd50f50f9-a532-4484-a71a-86731f76b154',
          'b0f98896-e2a4-4fc5-9f7f-6ead0cf2f1c6',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '66f7c482-58dc-4f23-89d9-f93037689859',
          'da55650b-b03a-4b94-af98-94026b6548f1',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          'ca2241ba-d1fe-4877-b37a-a9f3080e8428',
          '11bd4118-8b0c-4a21-8a53-7dbeec6b27e8',
          '24ab0774-80b6-41c5-9890-6a76dd1f6062',
          '0c39f779-ce6e-4392-bb7c-bd8a80e8be51',
          '3841ace9-f179-4c56-9824-64df459ec6b0',
          'f1212981-366b-4bec-ad7b-2de61372de39',
          '58a27259-c7a8-4a9c-b5ff-ade33cc27f95',
          '5b4f7128-8b99-4556-84ba-1e865679c75e',
          '54b9af26-85b6-42d7-8327-ca9e1855b7e9',
          'f8aa3a55-f862-46df-aef6-e065d3c49755',
          'ba9d1e26-3786-4639-a862-288de21241ff',
          '5b28d180-96da-4733-93f8-bfaf62dd2cd4',
          '9ffb01d5-012c-4e15-bd4c-0c210c3e06cf',
          '312de42b-f57a-46ea-b850-e9248c3a6371',
          '52c9baf6-3dc5-4ea7-9c63-41c640157abe',

        ]
        this.addForm.menuList = this.addForm.menuList.concat(arr)
        this.$refs.limittree.setCheckedKeys(this.addForm.menuList)
      }else {
        console.log(this.addForm.depManager)
        if (this.addForm.depManager == true||this.addForm.approveListSeal.length>0) {
        //包含了案件审批，用章审批，投标审批和全部案件
         let arr = [
          '78ba94ef-3ea6-4170-a5a4-83d850f5a1bb',
          '0f643717-24a1-4290-ac34-a1ab4c94aecd',
          '67091148-bb86-4376-9e01-aa76f86046fa',
          '35e6af5f-e7e5-40e8-aa08-6565669d03a1',
          '26e1a994-1e53-497b-b9bf-f0950c8e8b77',
          '3e15d5b7-70eb-4fc0-a31f-204a1362fbd3',
          'ca0ca2f8-cdfe-4e33-a067-6b6770847f01',
          '8c62b3e1-7be8-4aa2-9bc5-2d04d3175be3',
          'df9142a1-dbb6-413d-a145-747ab0401f1f',
          '1f9e9a99-838f-4eee-b2f3-d4b53c048f1b',
          'f34107f3-3a21-4442-8284-0106a0cdedfc',
          '22802200-1427-47ab-93a1-aa33bf20837e',
          'a85a43f4-f8f6-41e6-a6e1-f44c6faf9dbe',
          '6b08e6fd-d9a2-4713-ae3e-58404a7ecefd',
          '435ed88f-954c-4ab1-bdb0-9f2153b9f25a',
          '6ea098ae-19bb-4ad8-9c0b-9744a8a318b2',
          '58e7f87e-488b-4cee-8670-2ddd24a5c202',
          '85119374-93ca-4dc6-a447-40b90b427e73',
          'bcc57b67-af17-42cc-a5c1-82aed973d764',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          '367da928-1ab5-4183-8653-1b016e0e7f0f',
          '26963258-9a01-4f50-9489-7d6490c0c7e9',
          'da9f7d5d-7f04-468b-8f28-f77a17c4249f',
          '65693754-7826-42e5-bce6-d64a3532f277',
          '934ff88c-2928-46cf-8236-8304e362442e',
          '4aad1c9f-2dc9-4e0b-b080-d947bedec06e',
          '7048a989-56a0-4216-a865-a86ca98ba11c',
          'f3ad7ed8-bd05-4927-8857-2821a52dd78c',
          'd50f50f9-a532-4484-a71a-86731f76b154',
          'b0f98896-e2a4-4fc5-9f7f-6ead0cf2f1c6',
          'bece7f82-3c60-4af2-a75c-d4e4821a6815',
          'c54b8bff-ff0b-434a-b875-abbafd42446e',
          '66f7c482-58dc-4f23-89d9-f93037689859',
          'da55650b-b03a-4b94-af98-94026b6548f1',
          '066c8bec-6da0-47b4-b362-d9ee2e43e7b2',
          '4d0c334e-2fde-45a7-ac33-b907185989b2',
          'ee4127bc-176a-4444-acd8-a5a9ce256bf4',
          '9f78e0d1-bb02-4fca-bf7a-544b017bb246',
          '9ac30434-6083-4f67-85cd-94e12e99f30d',
          'aca40b83-8c45-4d50-b251-c01293c7fb66',
          '861c7468-4888-4143-ace9-ad96fae18a13',
          'ca2241ba-d1fe-4877-b37a-a9f3080e8428',
          '11bd4118-8b0c-4a21-8a53-7dbeec6b27e8',
          '24ab0774-80b6-41c5-9890-6a76dd1f6062',
          '0c39f779-ce6e-4392-bb7c-bd8a80e8be51',
          '3841ace9-f179-4c56-9824-64df459ec6b0',
          'f1212981-366b-4bec-ad7b-2de61372de39',
          '58a27259-c7a8-4a9c-b5ff-ade33cc27f95',
          '5b4f7128-8b99-4556-84ba-1e865679c75e',
          '54b9af26-85b6-42d7-8327-ca9e1855b7e9',
          'f8aa3a55-f862-46df-aef6-e065d3c49755',
          'ba9d1e26-3786-4639-a862-288de21241ff',
          '5b28d180-96da-4733-93f8-bfaf62dd2cd4',
          '9ffb01d5-012c-4e15-bd4c-0c210c3e06cf',
          '312de42b-f57a-46ea-b850-e9248c3a6371',
          '52c9baf6-3dc5-4ea7-9c63-41c640157abe',

        ]
        this.addForm.menuList = this.addForm.menuList.concat(arr)
        this.$refs.limittree.setCheckedKeys(this.addForm.menuList)
      }
        else{
          this.$refs.limittree.setCheckedKeys(this.intialMenu)
        }
        
      }
    },
    //编辑
    editClick(row) {
      this.dialogFormTitle = '编辑用户'
      // if(this.count!=0){
      //   this.$refs.tree.setCheckedKeys([]);
      //             this.$refs.tree.setCheckedNodes([]);
      //             this.count=this.count+1
      // }

      this.addForm = JSON.parse(JSON.stringify(row))
      // console.log(this.addForm)
      if(this.addForm.code.includes("org-jk02f-")){
        this.isZong=true
      }else{
        this.isZong=false
        this.addForm.conflict=null
      }
      // console.log(this.addForm.orgId)
      var approveList = this.addForm.approveList
      if (approveList != null) {
        var sealapproveList = []
        var caseapproveList = []
        approveList.forEach((value, index, array) => {
          if (value != null) {
            if (value.includes('_seal')) {
              sealapproveList.push(value)
            } else {
              caseapproveList.push(value)
            }
          }
        })
        this.addForm.approveListCase = caseapproveList
        this.addForm.approveListSeal = sealapproveList
      } else {
        this.addForm.approveListCase = []
        this.addForm.approveListSeal = []
      }

      let arr = []
      arr.push(this.addForm.orgId)
      this.addForm.orgId = arr

      this.dialogAddVisible = true
    },
    refreshData() {
      this.$forceUpdate()
    },
    //添加dialog确定按钮
    confirmClick() {
      if (
        this.$refs.tree.getCheckedKeys()[0] == null ||
        this.$refs.tree.getCheckedKeys()[0] == ''
      ) {
        this.$message.error('请选择所属部门')
        return
      }
      this.$refs['addRuleForm'].validate((valid) => {
        if (valid) {
          // console.log('approveList', this.addForm.approveListCase)
          var approveList
          if (
            this.addForm.approveListCase != undefined ||
            this.addForm.approveListCase !== undefined
          ) {
            approveList = this.addForm.approveListCase.concat(
              this.addForm.approveListSeal
            )
          }
          if (this.dialogFormTitle == '添加用户') {
            let Params = {
              //id: this.addForm.id,
              Username: this.addForm.username,
              Nikename: this.addForm.nikename,
              Tel: this.addForm.tel,
              OrgId: this.$refs.tree.getCheckedKeys()[0],
              MenuList: this.$refs.limittree.getCheckedKeys(),
              DepManager: this.addForm.depManager,
              RiskControler: this.addForm.riskControler,
              CriminalRiskControler: this.addForm.criminalRiskControler,
              Practice: this.addForm.practice,
              Conflict:this.addForm.conflict,
              ApproveList: approveList,
              chargeList: this.$refs.chargeList.getCheckedKeys()
            }
            addMemberList(Params)
              .then((res) => {
                if (res.data.status != 'success') {
                  this.$message.error(res.data.message)
                  return
                }
                if (res.status == 200) {
                  if (res.data.status == 'success') {
                    this.$message.success('添加成功')
                    this.search()
                    this.$refs.limittree.setCheckedKeys([])
                    this.$refs.tree.setCheckedKeys([])
                    this.$refs.tree.setCheckedNodes([])
                  } else {
                    this.$message.error(res.data.message)
                  }
                } else {
                  this.$message.error('添加失败')
                }
              })
              .catch(() => {
                this.$message.error('新增出错')
              })
            this.dialogAddVisible = false
          } else {
            let Params = {
              id: this.addForm.id,
              Username: this.addForm.username,
              Nikename: this.addForm.nikename,
              Tel: this.addForm.tel,
              OrgId: this.$refs.tree.getCheckedKeys()[0],
              MenuList: this.$refs.limittree.getCheckedKeys(),
              DepManager: this.addForm.depManager,
              RiskControler: this.addForm.riskControler,
              CriminalRiskControler: this.addForm.criminalRiskControler,
              ApproveList: approveList,
              Practice: this.addForm.practice,
              Conflict:this.addForm.conflict==''?null:this.addForm.conflict,
              chargeList: this.$refs.chargeList.getCheckedKeys()
            }

            updateMemberList(Params)
              .then((res) => {
                if (res.data.status != 'success') {
                  this.$message.error(res.data.message)
                  return
                }
                if (res.status == 200) {
                  this.$message.success('编辑成功')
                  // this.search()
                  if (this.$refs.searchTree.getCheckedNodes().length != 0) {
                    this.orgSearch(
                      this.$refs.searchTree.getCheckedNodes()[0].id,
                      this.currentPage
                    )
                  } else {
                    this.search()
                  }
                  this.$refs.limittree.setCheckedKeys([])
                  this.$refs.tree.setCheckedKeys([])
                  this.$refs.tree.setCheckedNodes([])
                } else {
                  this.$message.error('添加失败')
                }
              })
              .catch(() => {
                this.$message.error('编辑出错')
              })
            this.dialogAddVisible = false
          }
        } else {
          this.$message.error('校验错误')
          return false
        }
      })
    },
    // 关闭dialog时清空表单
    closeForm() {
      this.$refs['addRuleForm'].resetFields()
      this.$refs.limittree.setCheckedKeys([])
      this.$refs.tree.setCheckedKeys([])
      this.$refs.chargeList.setCheckedKeys([])
      this.dialogAddVisible = false
    },
    //禁用
    forbidClick(row) {
      let Params = {
        id: row.id,
        status: 1
      }
      deleteMemberList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.$message.success('禁用成功')
            this.search()
          } else {
            this.$message.error('禁用失败')
          }
        })
        .catch(() => {
          this.$message.error('禁用出错')
        })
    },
    //启用
    openClick(row) {
      let Params = {
        id: row.id,
        status: 0
      }
      deleteMemberList(Params)
        .then((res) => {
          if (res.data.status != 'success') {
            this.$message.error(res.data.message)
            return
          }
          if (res.status == 200) {
            this.$message.success('启用成功')
            this.search()
          } else {
            this.$message.error('禁用失败')
          }
        })
        .catch(() => {
          this.$message.error('启用出错')
        })
    },
    //删除
    deleteClick(row) {
      this.$confirm(`您确定删除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then((_) => {
          let Params = {
            id: row.id,
            status: 9
          }
          deleteMemberList(Params)
            .then((res) => {
              if (res.data.status != 'success') {
                this.$message.error(res.data.message)
                return
              }
              if (res.status == 200) {
                this.search()
              } else {
                this.$message.error('删除失败')
              }
            })
            .catch(() => {
              this.$message.error('删除出错')
            })
        })
        .catch((_) => {})
    },
    //修改密码
    resetClick(row) {
      this.passwordId = row.id
      this.messageVisible = true
      // this.messageForm.original = row.message
    },
    resetPassword(row){
      ResetPassword({Id:row.id}).then((res)=>{
        if(res.data.status=='success'){
          this.$message.success("重置成功")
        }else {
          this.$message.error(res.data.message)
        }
      })
    },
    closeMessage() {
      this.messageForm = {}
      this.messageVisible = false
    },
    //密码确定
    messageSubmitForm() {
      this.$refs['messageform'].validate((valid) => {
        if (valid) {
          let Params = {
            id: this.passwordId,
            OldPassword: this.messageForm.OldPassword,
            NewPassword: this.messageForm.NewPassword
          }
          updatePassword(Params)
            .then((res) => {
              if (res.data.status != 'success') {
                this.$message.error(res.data.message)
                return
              }
              if (res.status == 200) {
                this.$message.success('修改密码成功')
                this.messageForm = {}
              } else {
                this.$message.error('修改密码失败')
              }
            })
            .catch(() => {
              this.$message.error('查询出错')
            })
          this.messageVisible = false
        } else {
          this.$message.error('校验错误')
          return false
        }
      })
    },
    messageCancel() {
      this.$refs['messageform'].resetFields()
      this.messageVisible = false
      this.messageForm = {}
    },

    //更多筛选
    moreSelect() {
      // //更多选择
      // this.$refs.choose.blur()
      this.dialogMoreVisible = true
    },
    closeMoreForm() {
      // this.formMore = {}
      this.dialogMoreVisible = false
    },
    // //恢复选择状态
    // restoreSelection() {
    //   if (!this.$refs.multipleTable) return;
      
    //   this.tableData.forEach(row => {
    //     if (this.selectedRowIds.has(row.id)) {
    //       this.$refs.multipleTable.toggleRowSelection(row, true);
    //     }
    //   });
    // },
    //批量删除
    batchDelete(){
      console.log(this.selectedRowIds)
      if(this.selectedRows.length==0){
        this.$message.error("请选择需要删除的数据")
        return
      }else{
        this.$confirm(`确认删除选中的所有人员?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then((_) => {
          let Params = {
            id: Array.from(this.selectedRowIds)
          }
          UserDelete(Params)
            .then((res) => {
              if (res.data.status != 'success') {
                this.$message.error(res.data.message)
                return
              }
              if (res.status == 200) {
                this.clearAllSelection()
                this.search()
              } else {
                this.$message.error('删除失败')
              }
            })
            .catch(() => {
              this.$message.error('删除出错')
            })
        })
        .catch((_) => {})
      }
      
    },
    handleSelectionChange(selection){
    
      // 获取当前页新选中的行
      const newlySelected = selection.filter(row => 
        !this.selectedRowIds.has(row.id)
      );
    
    // 获取当前页取消选中的行
    const newlyUnselected = this.selectedRows.filter(row => 
      this.tableData.some(tRow => tRow.id === row.id) && 
      !selection.some(sRow => sRow.id === row.id)
    );
    
    // 更新选中项
    newlySelected.forEach(row => {
      this.selectedRows.push(row);
      this.selectedRowIds.add(row.id);
    });
    
    // 移除取消选中的项
    newlyUnselected.forEach(row => {
      const index = this.selectedRows.findIndex(r => r.id === row.id);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
        this.selectedRowIds.delete(row.id);
      }
    });
    console.log(this.selectedRowIds)
    },
    
    clearAllSelection() {
      // 清除当前页选择
      this.$refs.multipleTable.clearSelection();
      
      // 重置存储的选择状态
      this.selectedRows = [];
      this.selectedRowIds.clear();
      
      // 如果需要，可以添加提示
      // this.$message.success('已清除所有选择');
    },
  },
  computed: {
    // total() {
    //   return this.tableData.length;
    //   // return 9
    // },
  }
}
</script>
  
<style lang="less" scoped>
.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

#join {
  //针对火狐浏览器
  scrollbar-color: rgba(144, 147, 153, 0.4) transparent;
  /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin;

  /* 滚动条宽度有三种：thin、auto、none */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.4);
    border-radius: 0.225rem;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar {
    /* 对应纵向滚动条的宽度 */
    width: 0.525rem;
    /* 对应横向滚动条的宽度 */
    // background-color: #2bc887;
  }

  // position: relative;
  .search {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;

    .el-input {
      width: 20%;
    }

    //级联选择器单选框样式
    .cascader ::v-deep .el-radio__inner {
      top: -18px;
      left: -19px;
      border-radius: 0;
      border: 0;
      width: 170px;
      height: 34px;
      background-color: transparent;
      cursor: pointer;
      box-sizing: border-box;
      position: absolute;
    }

    .cascader ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: transparent !important;
    }

    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }

    .el-select {
      margin: 0 10px;
      width: 150px;
    }
  }

  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    // float: right;
    display: flex;
    justify-content: space-between;

    .el-pagination {
      padding-right: 50px;
    }
  }

  .fj {
    // display: inline-flex;
    display: flex;
    align-items: center;
    background: #f5f7fa;
    justify-content: flex-start;
    padding: 10px;
    padding-right: 20px;
    margin-bottom: 10px;
  }

  .input {
    width: 75%;
  }

  .img {
    width: 100%;
  }

  .word {
    line-height: 18px;
    cursor: default;
  }

  .look {
    color: #fe964a;
  }

  .down {
    color: #2bc887;
    margin-left: 10px;
  }

  .dialog-footer {
    margin-bottom: 5%;
  }

  .select {
    width: 10vw;
    margin-bottom: 1rem;
  }

  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
  